import { getIsDevelopment } from '@/utils/app'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useSignupStore } from '@/stores/signup'
import { useWomenSignupStore } from '@/stores/womenSignup'
import { stripWebsiteAndLocaleAndCountry } from '@/utils/general'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const appStore = useAppStore()
  const authStore = useAuthStore()
  const signupStore = useSignupStore()
  const womenSignupStore = useWomenSignupStore()

  datadogRum.init({
    applicationId: config.public.DATADOG_APP_ID,
    clientToken: config.public.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'nuxt-frontend',
    env: config.public.DD_ENV,
    version: config.public.DD_VERSION,
    allowedTracingUrls: [(url) => url.startsWith(config.public.API_URL)],
    sessionSampleRate: getIsDevelopment(config?.public) ? 100 : 20,
    sessionReplaySampleRate: 5,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    traceSampleRate: 0,
    traceContextInjection: 'sampled',
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {

      event.context = event.context || {}

      const url = stripWebsiteAndLocaleAndCountry(event.view.url)

      if (event.type === 'view') {
        event.context.fullUrl = `${event.view.url}`
        event.view.url = `${config.public.BASE_URL}${url}`

        event.context.country = appStore.country
        event.context.locale = appStore.locale

        if (authStore.userId) {
          event.context.userId = authStore.userId
        } else if (signupStore.form.prospectId) {
          event.context.prospectId = signupStore.form.prospectId
        } else if (womenSignupStore.form.prospectId) {
          event.context.prospectId = womenSignupStore.form.prospectId
        }

        return true
      }

      return true
    }
  })

  datadogLogs.init({
    clientToken: config.public.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'nuxt-frontend',
    env: config.public.DD_ENV,
    version: config.public.DD_VERSION,
    forwardErrorsToLogs: false,
    forwardConsoleLogs: [],
    sessionSampleRate: 100
  })

  // Also possible
  nuxtApp.hook('vue:error', (error, instance, info) => {
    // handle error, e.g. report to a service
    const context = {
      vueErrorInfo: info,
      component: instance
        ? {
            name: instance.$options?.name || instance.$options?.__name || 'Unknown',
            props: instance.$props || {},
            data: instance.$data ? Object.keys(instance.$data) : []
          }
        : null,
      route: nuxtApp.$router?.currentRoute?.value
        ? {
            path: nuxtApp.$router.currentRoute.value.path,
            name: nuxtApp.$router.currentRoute.value.name,
            params: nuxtApp.$router.currentRoute.value.params,
            query: nuxtApp.$router.currentRoute.value.query
          }
        : null,
      country: appStore.country,
      locale: appStore.locale
    }

    if (authStore.userId) {
      context.userId = authStore.userId
    } else if (signupStore.form.prospectId) {
      context.prospectId = signupStore.form.prospectId
    } else if (womenSignupStore.form.prospectId) {
      context.prospectId = womenSignupStore.form.prospectId
    }

    datadogRum.addError(error, context)
  })
})
